import React from 'react';
import UsersList from '../components/UsersList';

const UsersPage = () => (
    <div className="page-contents">
        <UsersList />
    </div>
);

export default UsersPage;
